import React, { useEffect } from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { isNumber } from 'lodash';

import { Typography, TypographyProps } from 'components/v2';

import { TypographyChatActivityCount_Query$key } from './__generated__/TypographyChatActivityCount_Query.graphql';

export interface TypographyChatActivityCountProps extends Omit<TypographyProps, 'classes'> {
  fragmentRef: TypographyChatActivityCount_Query$key;
  onChatActivityCountChange?: (count: number) => void;
}

const TypographyChatActivityCount: React.FC<TypographyChatActivityCountProps> = ({
  fragmentRef,
  onChatActivityCountChange,
  ...rest
}) => {
  const { chatActivityCount } = useFragment<TypographyChatActivityCount_Query$key>(
    graphql`
      fragment TypographyChatActivityCount_Query on Query
        @argumentDefinitions(filter: { type: "FilterChatActivityInput" }) {
        chatActivityCount(filter: $filter)
      }
    `,
    fragmentRef,
  );

  useEffect(() => {
    if (onChatActivityCountChange && isNumber(chatActivityCount)) {
      onChatActivityCountChange(chatActivityCount);
    }
  }, [onChatActivityCountChange, chatActivityCount]);

  return (
    <Typography variant="inherit" {...rest}>
      {chatActivityCount}
    </Typography>
  );
};

export default TypographyChatActivityCount;
